module.exports = __webpack_public_path__ + "img/shop_C_1.0e5266e7.png";